import { render, staticRenderFns } from "./CourseGroup.vue?vue&type=template&id=9df13346&scoped=true"
import script from "./CourseGroup.vue?vue&type=script&lang=js"
export * from "./CourseGroup.vue?vue&type=script&lang=js"
import style0 from "./CourseGroup.vue?vue&type=style&index=0&id=9df13346&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9df13346",
  null
  
)

export default component.exports